// extracted by mini-css-extract-plugin
export default {"container":"MainQr_container__ZPBMm","showQr":"MainQr_showQr__htK-p","qr":"MainQr_qr__xXshV"};